import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ActivityModal from './activity-modal';
import { fetchfralogsWorkdays, filterAction,resetFilterAction } from '../actions/index';
import * as apiConstants from '../../../constants/const';
import HoursOfServiceModal from './hours-of-service-modal';
import FRAReportWorkday from './fra-report-workday';
import CommentsModal from './comments-modal';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/src/SuperResponsiveTableStyle.css';
import AdminCommonSection from '../components/adminLayout';
import {Filters, Pagination, constants, KeolisSpinner} from './common/commonExport';
import PDFPrinting from './PDFPrinting';
import ExcelExportData from './ExcelExportData';
import FRAReportPinting from '../containers/FRAReportPinting';

class FRAReportWorkdays extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            totalRecords: '',
            numberOfPages: '',
            pageNum: 1, 
            filterState:{} 
        };
    }
    // get data for component
    getData(pageNum, filterObj){
        if(filterObj){
            filterObj = filterObj;
        } else {
            filterObj = this.state.filterState;
        }
        let self = this,
            authDetails = this.props.authDetails,
            role = authDetails.role;
            pageNum = filterObj.byPagination ? (pageNum) : (filterObj.byFilter ? 1 : pageNum);
        
            let fetchObj = { 
                url: constants.actionUrls.GET_FRA_LIST,
                role: role,
                certifyStatus: constants.FRA_REPORT,
                pageNum:pageNum,
                filterObj:filterObj
            }
            this.props.fetchfralogsWorkdays(fetchObj, function(response){
                self.setState({
                    numberOfPages: response.totalPages,
                    pageNum: pageNum
                })
            });
            localStorage.setItem('route', constants.FRA_REPORT);
        
    };
    // resetting the filter component
    resetFilter(filterObj){
        let self = this;   
        filterObj["outlaw"] = false;
        this.props.resetFilter(filterObj, function(response){
            self.setState({
                filterState:response
            });
        });
    }
    //called before the component renders
    componentWillMount() {
        let filterObj = this.props.filterState.defaultState ? this.props.filterState.defaultState:
                        this.props.filterState;
        this.resetFilter(filterObj);
    }
    //called after the component rendered
    componentDidMount(){
        let pageNum = this.state.pageNum;
        this.getData(pageNum);
    }    

    renderModal() {
        if (this.props.showModal && (this.props.modalName == constants.hosModals.Certified_Modal || this.props.modalName == constants.hosModals.Certify_Modal)) {
            return (
                <ActivityModal isLogUser = {true} islogAdmin = {true}/>
            );
        }
    }
    // rendering pagination component
    renderPagination() {
        let { pageNum, numberOfPages} = this.state,
        workdays = this.props.workdays, showPagination=false;
        if(workdays && workdays.length > 0 && numberOfPages > 1){
            showPagination = true;
        }
        return (<Pagination ShowPagination={showPagination} currentPage={pageNum}
            pageSize={numberOfPages} GetData={(pageNum, filterObj) => this.getData(pageNum, filterObj)} />)
    }
    // rendering claimed workdays component
    renderWorkdays(){
        var ext_first_key, wdy_date, then, role = this.props.authDetails.role;
        if (this.props.isLoading) {
            return(
                <tr>
                    <td>
                       <KeolisSpinner />
                    </td>
                </tr>
            );
        }
        else if (this.props.workdays && this.props.workdays.length >= 0) {

            var workdays = this.props.workdays;
            return(
                workdays.length == 0 ?
                <tr>
                    <td colSpan="100%">
                        No records available...
                    </td>
                </tr>
                :
                workdays.map(function (workday, index) {
                    return (
                        <FRAReportWorkday workday={workday} key={index}  role = {role} />
                    );
                })
            );
        } else {
            return(
                <tr>
                    <td>
                        <KeolisSpinner />
                    </td>
                </tr>
            )
        }
    }
    // filter in action
    getFilteredData(e, data){
        let pageNum = data.isResetFRA ? 1 : this.state.pageNum,filterObj = data;
        if(e){
            e.preventDefault();
        } 
        this.props.submitFilter(data);
        this.getData(pageNum, filterObj);
    }
    
  getSelectedCheckedData()
  {
    let arr = [];
    let checkboxs = document.getElementsByName('chkEmployee');     
    if (checkboxs && checkboxs.length > 0) {
        for (let i = 0; i < checkboxs.length; i++) {
            if (checkboxs[i].checked) {
                
               let selectedRow= checkboxs[i].id.split('_')
                 let selectedEmployee ={
                    employeeId:selectedRow[0],
                    workDate:selectedRow[1]
                 }

                arr.push(selectedEmployee);
            }
        
        }

        return arr;
    }
  }

  handleChkSelectAll()
  {
    let selectAll = document.getElementById('chkSelectAll');
    let checkboxs = document.getElementsByName('chkEmployee');     
    if (checkboxs && checkboxs.length > 0) {
        for (let i = 0; i < checkboxs.length; i++) {
            checkboxs[i].checked= selectAll.checked;          
            
            }       
        }
    
  }


  getSelectedData()
  {

   let selectedRows = this.getSelectedCheckedData();

  }



    render() {
        let compTitle = 'FRA Report';
        return (
            <AdminCommonSection compTitle={compTitle} admin={true}
            tblBody={
            <div>
                <Filters getData = {(e, data) => this.getFilteredData(e, data)} />
                    <PDFPrinting Page="Projects" compTitle={compTitle} pageNo={this.state.pageNum} getSelectedCheckedData ={this.getSelectedCheckedData.bind(this)} />
                    <FRAReportPinting Page="FRA Report" hidden={false} isSelectedData={true} getSelectedCheckedData ={this.getSelectedCheckedData.bind(this)} />
                    <ExcelExportData Page="Projects" compTitle={compTitle} pageNo={this.state.pageNum} getSelectedCheckedData ={this.getSelectedCheckedData.bind(this)} />
                <div id="tblMainActivities">
                    <table className="table table-striped table-bordered_header table-condensed">
                        <thead className="thead-default">
                            <tr className="text-center">
                               <th className='width5 text-center'>
                               <input type="checkbox" name="chkSelectAll" id="chkSelectAll" onClick={()=>this.handleChkSelectAll()}/>
                               </th>
                                <th className="text-center">Employee ID</th>
                                <th className="text-center">First Name</th>
                                <th className="text-center">Last Name</th>
                                <th className="text-center">Service Date</th>
                                <th className="text-center">Type</th>
                                <th className="text-center">Total HOS</th>
                                <th className="text-center">Certify Date</th>
                                <th className="text-center">Status</th>
                            </tr>

                        </thead>
                        <tbody>
                        {
                            this.renderWorkdays()
                        }
                        </tbody>
                    </table >
                    {
                        this.renderModal()
                    }
                    </div>
                    {
                        this.renderPagination()
                    }
                    </div>
            }/>
        )
    }
}

function mapStateToProps(state) {
    return {
        workdays: state.workdays.workdays,
        isLoading: state.workdays.isLoading,
        showModal: state.modals.showModal,
        modalName: state.modals.modalName,
        workday: state.workday.workday,
        authDetails:state.authState,
        filterState:state.filter
    };
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            fetchfralogsWorkdays: fetchfralogsWorkdays,
            submitFilter: filterAction,
            resetFilter:resetFilterAction
        }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(FRAReportWorkdays);
